import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VMask from './VMask';
import CouponItem from './CouponItem';
import { batchApply } from '@/request/detail-new/index';
import Drip from 'drip';
import { typeMapToText } from '@/common/enums/discount-type';
export default {
  name: 'widget__promotionlist',
  components: {
    'v-mask': VMask,
    CouponItem: CouponItem
  },
  data: function data() {
    return {
      selected: null,
      isShowTop: false,
      isShowBottom: true,
      typeMapToText: typeMapToText
    };
  },
  mounted: function mounted() {
    // 先注册滚动事件
    this.$refs.box.addEventListener('scroll', this.scroll);
  },
  props: {
    preferenceList: {
      type: Array,
      value: []
    },
    onClose: {
      type: Function,
      default: function _default() {}
      // required: true,
    },

    supportWenhui: {
      type: Boolean
    },
    wenhuiActivityUrl: {
      type: String,
      value: ''
    },
    performanceId: {
      type: Number
    },
    businessBatchList: {
      type: Array,
      value: []
    },
    // 优惠信息列表
    promotionDetails: {
      type: Array,
      value: []
    }
  },
  computed: {
    isShowPreference: function isShowPreference() {
      var hasPreference = this.preferenceList && this.preferenceList.length > 0;
      return hasPreference;
    },
    isShowCoupon: function isShowCoupon() {
      var hasCoupon = this.businessBatchList && this.businessBatchList.length > 0;
      return hasCoupon;
    },
    showDiscountTips: function showDiscountTips() {
      return this.supportWenhui || this.isShowPreference || this.promotionDetails && this.promotionDetails.length > 0;
    }
  },
  methods: {
    // 监听滚动事件
    scroll: function scroll() {
      var _this$$refs$box = this.$refs.box,
        scrollTop = _this$$refs$box.scrollTop,
        clientHeight = _this$$refs$box.clientHeight,
        scrollHeight = _this$$refs$box.scrollHeight;
      if (scrollTop > 20) {
        this.isShowTop = true;
      } else {
        this.isShowTop = false;
      }
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isShowBottom = false;
      } else {
        this.isShowBottom = true;
      }
    },
    wenhuiClick: function wenhuiClick(url) {
      this.go(url);
    },
    receiveCoupon: function receiveCoupon(activityId) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var osName, params, res, code, msg;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              osName = Drip.UA.osName;
              params = {
                activityId: activityId,
                userAgent: navigator.userAgent.toLowerCase(),
                clientType: osName === 'ios' ? 1 : 4,
                projectId: _this.performanceId
              };
              _context.next = 4;
              return batchApply(params);
            case 4:
              res = _context.sent;
              code = res.code, msg = res.msg;
              if (code === 200) {
                _this.$toast('<div>领取成功</div>优惠券正在路上~', {
                  wordWrap: true
                });
              } else {
                if (msg) {
                  _this.$toast(msg);
                } else {
                  _this.$toast(_this.$ERROR_TEXT);
                }
              }
              setTimeout(function () {
                _this.$emit('changeCouponStatus');
              }, 2000);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};